const ENV = process.env.REACT_APP_ENVIRONMENT || "local";

let backendUrl = process.env.REACT_APP_LOCAL_BACKEND_URL;
if (ENV === "dev") {
  backendUrl = process.env.REACT_APP_DEV_BACKEND_URL;
} else if (ENV === "prod") {
  backendUrl = process.env.REACT_APP_PROD_BACKEND_URL;
} else {
  backendUrl = process.env.REACT_APP_LOCAL_BACKEND_URL;
}

const config = {
  backendUrl,
  environment: ENV,
};

export default config;
